// extracted by mini-css-extract-plugin
export default {"container":"FrBbpnSAs_nRWUx5JL6w"};